"use client";

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ConfirmDeleteModal.css";

export default function ConfirmDeleteModal({
  open,
  title,
  message,
  confirmText,
  cancelText,
  loading = false,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation("appointments");

  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape" && !loading) onCancel?.();
    };

    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, loading, onCancel]);

  if (!open) return null;

  return (
    <div
      className="cdm-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cdm-title"
      aria-describedby="cdm-desc"
      onClick={(e) => {
        if (e.target === e.currentTarget && !loading) onCancel?.();
      }}
    >
      <div className="cdm-modal1" role="document">

        <div className="cdm-icon-wrap">
          <div className="cdm-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" />
            </svg>
          </div>
        </div>

        <div className="cdm-header">
          <h3 id="cdm-title" className="cdm-title">
            {title || t("modal.confirmDeletion")}
          </h3>
        </div>

        <div id="cdm-desc" className="cdm-body">
          <p>{message}</p>
        </div>

        <div className="cdm-divider" />

        <div className="cdm-actions">
          <button type="button" className="cdm-btn cdm-cancel" onClick={onCancel} disabled={loading}>
            {cancelText || t("modal.cancel")}
          </button>

          <button type="button" className="cdm-btn cdm-confirm" onClick={onConfirm} disabled={loading}>
            {confirmText || t("modal.delete")}
          </button>
        </div>

      </div>
    </div>
  );
}